// Simple way to read version from package.json
const packageJson = require('../../../package.json');

module.exports = {
  version: packageJson.version
}; 